define('SuiteDynamics.Inserts.Collection',
    [
        'underscore',
        'Utils',
        'Session',
        'Item.Collection',
        'Profile.Model',
    ],
    function (
        _,
        Utils,
        Session,
        ItemCollection,
        ProfileModel
    )
{
    'use strict';

    return ItemCollection.extend({
        url: function() {
            var profile = ProfileModel.getInstance();
            return Utils.addParamsToUrl(
                profile.getSearchApiUrl(),
                _.extend({}, this.searchApiMasterOptions, Session.getSearchApiParams(), {
                    fieldset: 'details'
                }),
                profile.isAvoidingDoubleRedirect()
            );
        }
    });
});
